import { makeProjectIdentifier } from '@neptune/shared/core-project-util';
import { Entity, fetchEntityChunkByShortId } from '@neptune/shared/entity-domain';
import { queryAllAttributesForExperiment } from '@neptune/shared/leaderboard-domain';
import { Attribute, knownAttributes } from 'domain/experiment/attribute';

const wellKnownFields: string[] = knownAttributes;

export async function fetchEntityWorkaround(
  organizationName: string,
  projectName: string,
  shortId: string,
): Promise<Entity> {
  // We need to fetch entity with small subset of fields just get some basic information as it is missing in query attributes endpoint
  const basicEntityPromise = fetchEntityChunkByShortId(
    organizationName,
    projectName,
    shortId,
    wellKnownFields,
  );

  const attributesResultPromise = queryAllAttributesForExperiment({
    projectIdentifier: makeProjectIdentifier(organizationName, projectName),
    shortId,
    // this endpoint will paginate inside cluster between LB and ES to save time on roundtrips
    limit: 500_000,
  });

  const [basicEntity, attributesResult] = await Promise.all([
    basicEntityPromise,
    attributesResultPromise,
  ]);

  // basic entity attributes are used to make sure they were not stripped by 500k limit of page size,
  // and we put them in front to optimize most common linear searches.
  const attributes = basicEntity.attributes; // No copy! we will extend the array we got from response.

  appendAttributesWithoutRepetitions({
    appendTo: attributes,
    appendFrom: attributesResult?.result.attributes ?? [],
  });

  const returnValue = {
    ...basicEntity,
    attributes,
  };

  return returnValue;
}

function appendAttributesWithoutRepetitions({
  appendTo,
  appendFrom,
}: {
  appendTo: Attribute[];
  appendFrom: Attribute[];
}) {
  const alreadyPresent = new Set();

  for (const attribute of appendTo) {
    alreadyPresent.add(attribute.attributeName);
  }

  for (const attribute of appendFrom) {
    if (alreadyPresent.has(attribute.attributeName)) {
      continue;
    }

    appendTo.push(attribute);
  }
}
